/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalPricingList.vue?vue&type=template&id=64971e60&scoped=true"
import script from "./ModalPricingList.vue?vue&type=script&lang=js"
export * from "./ModalPricingList.vue?vue&type=script&lang=js"
import style0 from "./ModalPricingList.vue?vue&type=style&index=0&id=64971e60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64971e60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64971e60')) {
      api.createRecord('64971e60', component.options)
    } else {
      api.reload('64971e60', component.options)
    }
    module.hot.accept("./ModalPricingList.vue?vue&type=template&id=64971e60&scoped=true", function () {
      api.rerender('64971e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalPricingList.vue"
export default component.exports